import React from 'react';
import WorkVisualsList from './WorkVisualsList';
import WorkVisualsPager from './WorkVisualsPager';
import WorkVisualsInformations from './WorkVisualsInformations';
import { TweenLite, Expo, Bounce, Elastic } from "gsap/all";

class WorkVisualSlider extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            activeIndex: 0
        };

        this.slidesCount = this.props.assets.length;

        this.onPrev = this.onPrev.bind(this);
        this.onNext = this.onNext.bind(this);
        this.onMouseEnter = this.onMouseEnter.bind(this);
        this.onMouseLeave = this.onMouseLeave.bind(this);
        this.onPagerItemClick = this.onPagerItemClick.bind(this);
        this.rewind = this.rewind.bind(this);
    }

    componentDidMount() {
        window.addEventListener('scroll', this.rewind);
    }

    componentWillUnmount() {
        window.removeEventListener('scroll', this.rewind);
    }

    onPrev(e) {
        this.onClick(e);

        if(this.state.activeIndex - 1 >= 0) {
            this.setState({activeIndex: this.state.activeIndex - 1});
        }
        else {
            this.setState({activeIndex: this.slidesCount - 1});
        }
    }

    onNext(e) {
        this.onClick(e);

        if(this.state.activeIndex + 1 < this.slidesCount) {
            this.setState({activeIndex: this.state.activeIndex + 1});
        }
        else {
            this.setState({activeIndex: 0});
        }
    }

    onClick(e) {
        let target = e.target;
        TweenLite.to(target, 0.2, {scaleX: 1.2, scaleY: 0.6, transformOrigin: 'bottom center', ease: Expo.easeOut});
        TweenLite.to(target, 0.8, {scaleX: 1, scaleY: 1, delay: 0.2, ease: Elastic.easeOut});
    }

    onMouseEnter(e) {
        TweenLite.to(e.target, 0.4, {scaleX: 1.2, scaleY: 0.95, transformOrigin: 'bottom center', ease: Expo.easeOut});
    }

    onMouseLeave(e) {
        TweenLite.to(e.target, 0.4, {scaleX: 1, scaleY: 1.1, transformOrigin: 'bottom center', ease: Bounce.easeOut});
    }

    onPagerItemClick(e) {
        e.preventDefault();

        let target = e.target;
        
        if(target.hasAttribute('data-index')) {
            let index = parseInt(target.getAttribute('data-index'), 10);
            this.setState({activeIndex: index});
        }
    }

    rewind() {
        if(this.state.activeIndex !== 0) {
            this.setState({activeIndex: 0});
        }
    }

    render() {
        return (
            <div className={`work ${(this.props.sliderNavAlign === 'middle') ? 'abs-pager' : ''}`}>
                <WorkVisualsPager assets={this.props.assets} onClickCallback={this.onPagerItemClick} activeIndex={this.state.activeIndex} alignment={this.props.sliderNavAlign}/>

                <div className="work-visuals-wrapper">
                    <WorkVisualsInformations details={this.props.details.left} side="left" />

                    <WorkVisualsList assets={this.props.assets} projectPath={this.props.projectPath} activeIndex={this.state.activeIndex} rotation={this.props.rotation}/>

                    <WorkVisualsInformations details={this.props.details.right} side="right" />

                    <div className={`work-nav prev-visual noselect barlow-bl-it red ${this.props.sliderNavAlign}`} onClick={this.props.assets.length > 1 ? this.onPrev : undefined} onMouseEnter={this.props.assets.length > 1 ? this.onMouseEnter : undefined} onMouseLeave={this.props.assets.length > 1 ? this.onMouseLeave : undefined}>{this.props.projectName[0]}</div>
                    <div className={`work-nav next-visual noselect barlow-bl-it red ${this.props.sliderNavAlign}`} onClick={this.props.assets.length > 1 ? this.onNext : undefined} onMouseEnter={this.props.assets.length > 1 ? this.onMouseEnter : undefined} onMouseLeave={this.props.assets.length > 1 ? this.onMouseLeave : undefined}>{this.props.projectName[this.props.projectName.length - 1]}</div>
                </div>
            </div> 
        );
    }
};

export default WorkVisualSlider;


// WEBPACK FOOTER //
// ./src/components/WorkVisualsSlider.js